import { Derivation } from '../interfaces/Derivation';

export function mapDerivationApiToDerivation(
  derivationApi: Derivation
): Derivation {
  return {
    id: derivationApi.id,
    from: derivationApi.from,
    dt: derivationApi.dt,
    description: derivationApi.description,
    sessionId: derivationApi.sessionId,
    status: derivationApi.status,
    user: derivationApi.user,
    anotations: derivationApi.anotations,
    caseId: derivationApi.caseId,
    openDt: derivationApi.openDt,
    tags: derivationApi.tags,
    created_at: derivationApi.created_at,
    updated_at: derivationApi.updated_at,
    conversation: derivationApi.conversation,
  };
}
